"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.pipe = pipe;
exports["default"] = void 0;

var identity = function identity(x) {
  return x;
};

function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  if (!fns.length) fns = [identity];
  return fns.reduce(function (f, g) {
    return function () {
      return g(f.apply(void 0, arguments));
    };
  });
}

var _default = pipe;
exports["default"] = _default;